import styled from 'styled-components';

export const StyledWrapper = styled.div`
  min-width: 0;
  max-width: 100%;

  .catering-setup-label {
    font-size: 14px;
    line-height: 18px;
    color: #4e5457;
  }

  .catering-setup-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    min-width: 0;
    max-width: 100%;
  }

  .catering-setup-input {
    flex: 0 0 100px;
    width: 100px;
  }

  .catering-setup-row .ant-btn {
    flex-shrink: 0;
  }

  .catering-setup-help {
    display: block;
    margin: 8px 0 0;
    max-width: 100%;
    color: #717679;
    font-size: 12px;
    line-height: 18px;
  }

  .catering-setup-error {
    display: block;
    margin-top: 8px;
  }
`;
